import { WidgetId, WidgetSections } from 'src/lib/contexts/AnalyticsContext/types'
import { CheckWidget } from '../charts/common/CheckWidget'
import { ChartCardWithWidget } from '../ChartCard'
import DiscountConversionRateComparisonChart from '../charts/DiscountSection/ConversionRateComparisonChart'
import DiscountsComparisonTable from '../charts/DiscountSection/DiscountsComparisonTable'

const OrdersSection = () => {
  return (
    <div>
      {/* Charts */}
      <div className='space-y-6'>
        {/* Single Series Line Chart */}
        <div className='grid grid-cols-2 gap-4'>
          {/* Comparison Line Chart */}
          <CheckWidget widgetId={WidgetId.discounts_conversion_rate}>
            <ChartCardWithWidget widgetSection={WidgetSections.discounts} widgetId={WidgetId.discounts_conversion_rate}>
              <DiscountConversionRateComparisonChart forKey='conversion' isPercentage />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.discounts_average_order_value}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.discounts}
              widgetId={WidgetId.discounts_average_order_value}
            >
              <DiscountConversionRateComparisonChart forKey='average_order_value' isPercentage={false} />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.discounts_order_placed_comparison}>
            <ChartCardWithWidget
              widgetSection={WidgetSections.discounts}
              widgetId={WidgetId.discounts_order_placed_comparison}
            >
              <DiscountConversionRateComparisonChart forKey='completed_count' isPercentage={false} />
            </ChartCardWithWidget>
          </CheckWidget>

          <CheckWidget widgetId={WidgetId.discounts_your_discounts}>
            <ChartCardWithWidget widgetSection={WidgetSections.discounts} widgetId={WidgetId.discounts_your_discounts}>
              <DiscountsComparisonTable />
            </ChartCardWithWidget>
          </CheckWidget>
        </div>
      </div>
    </div>
  )
}

export default OrdersSection
